/**
 * @Description
 */

import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import V2AMap from '../../Map/V2AMap';
import { useMethods } from '@lhb/hook';
import V2DetailGroup from '../../Feedback/V2DetailItem/Group';
import V2Form from '@/common/components/Form/V2Form';
import { Col, Row, Image } from 'antd';
import V2DetailItem from '../../Feedback/V2DetailItem';
import V2LogRecord from '../../SpecialBusiness/V2LogRecord';
import { noImgSrc } from '@/common/utils/ways';
import { isArray } from '@lhb/func';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
// import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';

const DescriptionContent = (value, targetPunchInAlias) => {
  return (
    <div className={styles.descriptionContent}>
      {/* <div>时间：{value.checkDateTime || '-'}</div> */}
      <div>地点：{value.address || '-'}</div>
      <div className='mb-4'>{targetPunchInAlias}情况：{value.content || '-'}</div>
      <Image.PreviewGroup>
        {
          value.pictures.map((item, index) => {
            return (
              <span className='mr-4' key={index}>
                <Image
                  className={styles.descriptionImg}
                  width={48}
                  height={48}
                  src={item.url}
                  fallback={noImgSrc}
                />
              </span>
            );
          })
        }
      </Image.PreviewGroup>
    </div>
  );
};

const EditForm: FC<any> = ({
  detail,
  form,
  targetPunchInAlias,
}) => {
  useEffect(() => {
    const { requirement } = detail || {};
    requirement && form.setFieldValue('requirement', requirement);
    // isArray(taskPictures) && taskPictures.length && form.setFieldValue('taskPictures', taskPictures);
  }, [detail]);
  return (
    <V2Form form={form} className='mt-20'>
      <Row gutter={24}>
        <Col span={12}>
          <V2FormTextArea
            name='requirement'
            label={`${targetPunchInAlias}要求`}
            placeholder={`请输入${targetPunchInAlias}要求，最多300字`}
            maxLength={300}
            config={{
              showCount: true
            }}
          /></Col>
        {/* <Col span={12}>
          <V2FormUpload
            uploadType='image'
            label='上传图片'
            name='taskPictures'
            config={{
              maxCount: 5,
              size: 20,
              fileType: ['png', 'jpg', 'gif', 'jpeg', 'bmp']
            }}
          />
        </Col> */}
      </Row>
    </V2Form>
  );
};

interface MainProps {
  [p:string]: any;
};
const Main: FC<MainProps> = ({
  detail,
  isEdit,
  form,
  mainHeight,
  targetPunchInAlias,
}) => {
  const [mapIns, setMapIns] = useState<any>(null);
  const hasRecordList = useMemo(() => {
    const { recordList } = detail || {};
    return isArray(recordList) && !!recordList.length;
  }, [detail]);
  const methods = useMethods({
    renderMap: () => {
      if (!mapIns || !detail) return;
      const { lng, lat } = detail;
      mapIns.setCenter([lng, lat]);
      const marker = new window.AMap.Marker({
        position: [lng, lat],
        content: '<img src="https://staticres.linhuiba.com/project-custom/locationpc/flow/fixed_point.png" style="width: 22px;height: 26px;"/>',
        anchor: 'bottom-center',
      });
      mapIns.add(marker);
      mapIns.setFitView(marker);
    }
  });
  useEffect(() => {
    methods.renderMap();
  }, [mapIns, detail]);
  return (
    <div className='mt-12' style={{
      height: `${mainHeight}px`,
      overflowY: 'auto',
      overflowX: 'hidden',
      boxSizing: 'border-box'
    }}>
      <V2AMap
        loaded={setMapIns}
        height='300px'
        styleOpt={{
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      />
      {
        isEdit ? <EditForm
          detail={detail}
          form={form}
          targetPunchInAlias={targetPunchInAlias}
        />
          : <V2DetailGroup block={hasRecordList}>
            <Row gutter={16}>
              <Col span={12}>
                <V2DetailItem label={`${targetPunchInAlias}位置`} value={detail?.address}/>
              </Col>
              <Col span={12}>
                <V2DetailItem label='省市区'
                  // value={`${detail?.provinceName || '-'}/${detail?.cityName || '-'}/${detail?.districtName || '-'}`}
                  value={<>{detail?.provinceName}{detail?.cityName === detail?.provinceName ? '' : detail?.cityName}{detail?.districtName}</>}
                />
              </Col>
              <Col span={12}>
                <V2DetailItem label={`${targetPunchInAlias}要求`} value={detail?.requirement}/>
              </Col>
            </Row>
          </V2DetailGroup>
      }
      {
        hasRecordList ? <>
          <V2Title divider type='H2' text={`${targetPunchInAlias}记录`} className='mt-20'><div className='bold'>{targetPunchInAlias}记录</div></V2Title>
          <div className='pl-2'>
            <V2LogRecord items={detail.recordList.map((item) => {
              return {
                name: item.employeeName,
                time: <>{item.checkDateTime || '-'}</>,
                description: DescriptionContent(item, targetPunchInAlias),
                status: 'finish'
              };
            })}/>
          </div>
        </> : <></>
      }
    </div>
  );
};

export default Main;
